import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { IconNames } from '@whitesharx/starfall-frontend-ui-kit';

export const ONBOARDING_GAMES_COUNT = 3;

export const COMPLETED_ONBOARDING_GAMES_COUNT_KEY = 'completed-onboarding-games-count';

export const ONBOARDING_GAME_KEY = 'onboarding-game';

export const ONBOARDING_COMPLETED_AT_KEY = 'onboarding-completed-at';

export const PLAYER_COLOR: { white: 'w'; black: 'b' } = {
  white: 'w',
  black: 'b',
};

export const ONBOARDING_COMPLETED_KEY = 'onboarding-completed';

export enum GameMode {
  GAMEWITHOUTTIMERS = 'GAMEWITHOUTTIMERS',
  RAPID30 = 'RAPID30',
}

export enum GameResultTitle {
  victory = 'victory',
  defeat = 'defeat',
  draw = 'draw',
  canceled = 'canceled',
  stalemate = 'stalemate',
}

export const PREMOVE_KEY = 'premove';

const LT5_MOVES_COUNT = 'movesCount < 5';
const LT20_MOVES_COUNT = 'movesCount < 20';
const GTE20_MOVES_COUNT = 'movesCount >= 20';

type MovesCount = typeof LT5_MOVES_COUNT | typeof LT20_MOVES_COUNT | typeof GTE20_MOVES_COUNT;

type Expression = string;

export type GameMetaParams = {
  mode: GameMode;
  /** count of all moves */
  movesCount: number;
  /** time (in seconds) it took the player to make a move */
  moveTime?: number;
  /** count of left on board figures */
  figuresCount?: number;
  /** bot's time left */
  botLeftTime?: number;
  /** player's time left */
  playerLeftTime?: number;
};

export const TIMERS_BY_MODE = {
  [GameMode.RAPID30]: {
    whiteLeftTime: 30 * 60 * 1000,
    blackLeftTime: 30 * 60 * 1000,
  },
  [GameMode.GAMEWITHOUTTIMERS]: {
    whiteLeftTime: undefined,
    blackLeftTime: undefined,
  },
};

const GAMEWITHOUTTIMERS: Record<MovesCount, Expression> = {
  [LT5_MOVES_COUNT]: 'random(1, 2)',
  [LT20_MOVES_COUNT]: 'random(2, 3)',
  [GTE20_MOVES_COUNT]: 'random(2, 4)',
};

const RAPID: Record<MovesCount, Expression> = {
  [LT5_MOVES_COUNT]: '2',
  [LT20_MOVES_COUNT]: '2',
  [GTE20_MOVES_COUNT]: '2',
};

export const MOVE_TIME_LOGIC_BY_MODE = {
  [GameMode.RAPID30]: RAPID,
  [GameMode.GAMEWITHOUTTIMERS]: GAMEWITHOUTTIMERS,
};

const RESULTS = {
  TURN_TIME: {
    [GameResultTitle.victory]: {
      title: GameResultTitle.victory,
      description: t('game.opponent-time-expired'),
    },
    [GameResultTitle.defeat]: {
      title: GameResultTitle.defeat,
      description: t('game.your-time-expired'),
    },
  },
  SURRENDERED: {
    [GameResultTitle.victory]: {
      title: GameResultTitle.victory,
      description: t('game.opponent-resigned'),
    },
    [GameResultTitle.defeat]: {
      title: GameResultTitle.defeat,
      description: t('game.you-resigned'),
    },
  },
  CHECKMATED: {
    [GameResultTitle.victory]: {
      title: GameResultTitle.victory,
      description: t('game.opponent-checkmated'),
    },
    [GameResultTitle.defeat]: {
      title: GameResultTitle.defeat,
      description: t('game.you-checkmated'),
    },
  },
  ABORTED: {
    title: GameResultTitle.canceled,
    description: t('game.canceled'),
  },
  STALEMATE: {
    title: GameResultTitle.stalemate,
    description: t('game.no-legal-move'),
  },
  THREEFOLD: {
    title: GameResultTitle.draw,
    description: t('game.threefold'),
  },
  INSUFFICIENT_MATERIAL: {
    title: GameResultTitle.draw,
    description: t('game.insufficient-material'),
  },
  FIFTY_MOVES: {
    title: GameResultTitle.draw,
    description: t('game.fifty-moves'),
  },
};

const getResult = (isVictory: boolean) => (isVictory ? GameResultTitle.victory : GameResultTitle.defeat);

export const resultGetterMap = {
  TURN_TIME: (isVictory: boolean) => RESULTS.TURN_TIME[getResult(isVictory)],
  SURRENDERED: (isVictory: boolean) => RESULTS.SURRENDERED[getResult(isVictory)],
  CHECKMATED: (isVictory: boolean) => RESULTS.CHECKMATED[getResult(isVictory)],
  ABORTED: () => RESULTS.ABORTED,
  STALEMATE: () => RESULTS.STALEMATE,
  THREEFOLD: () => RESULTS.THREEFOLD,
  INSUFFICIENT_MATERIAL: () => RESULTS.INSUFFICIENT_MATERIAL,
  FIFTY_MOVES: () => RESULTS.FIFTY_MOVES,
};

export const GAME_MODE_ICONS: Record<Exclude<GameMode, GameMode.GAMEWITHOUTTIMERS>, IconNames> = {
  [GameMode.RAPID30]: 'rapid30',
};
